import { useState } from "react";
import { Link2, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

/**
 * <CopyDeepLinkButton url={absoluteUrl?} variant="outline" testId="copy-link-btn" />
 * - If `url` is omitted, copies the current page URL (including search & hash).
 * - Falls back to a textarea hack if navigator.clipboard is unavailable.
 */
export default function CopyDeepLinkButton({
  url,
  variant = "outline",
  size = "default",
  className = "",
  label = "Copy link",
  testId = "copy-deeplink-btn",
}) {
  const [copied, setCopied] = useState(false);

  const handle = async () => {
    const target = url || window.location.href;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(target);
      } else {
        const ta = document.createElement("textarea");
        ta.value = target;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.focus(); ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Could not copy link");
    }
  };

  return (
    <Button onClick={handle} variant={variant} size={size} className={className} data-testid={testId} title={url || "Copy this page link"}>
      {copied ? <Check className="w-4 h-4 mr-1" /> : <Link2 className="w-4 h-4 mr-1" />}
      {copied ? "Copied" : label}
    </Button>
  );
}
